import PendoButton from '../button/pendo-button.vue.js';
import PendoMediaCard from '../media-card/pendo-media-card.vue.js';
import PendoIcon from '../icon/pendo-icon.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import { filterItems } from './utils.js';
import TravelMixin from '../../mixins/travel.js';

var script = {
  name: 'PendoChooserGrid',
  components: {
    PendoMediaCard,
    PendoButton,
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  mixins: [TravelMixin],
  $travel: {
    refName: 'chooser-grid-item'
  },
  props: {
    value: {
      type: [Object, Array, String, Number],
      default: () => []
    },
    items: {
      type: Array,
      default: () => [{}]
    },
    multiple: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    selectLabel: {
      type: String,
      default: 'Select Item'
    },
    removeSelectionLabel: {
      type: String,
      default: 'Deselect Item'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filters: {
      type: [Object, Array],
      default: null
    }
  },
  data() {
    return {
      filterCache: null
    };
  },
  computed: {
    model() {
      if (this.value || this.value === 0) {
        return Array.isArray(this.value) ? this.value : [this.value];
      }
      return [];
    },
    visibleItems() {
      let visibleItems = this.items;
      if (this.filters && this.filters.length > 0) {
        this.filters.forEach(filter => {
          const {
            value,
            prop,
            filterFn
          } = filter;
          if (Array.isArray(value) && value.length === 0 || (value === undefined || value === '') && !filterFn) {
            return true;
          }
          const filterHandler = filterFn || this.getFilterHandler(prop);
          visibleItems = visibleItems.filter(item => filterHandler(item, filter));
        });
      }
      return visibleItems;
    }
  },
  watch: {
    visibleItems(visibleItems) {
      this.$emit('visible-items-change', visibleItems);
    }
  },
  created() {
    this.filterCache = Object.create(null);
  },
  methods: {
    getCardShadow(item) {
      if (this.isItemSelected(item)) {
        return 'never';
      }
      if (this.model.length && !this.multiple) {
        return 'never';
      }
      return 'hover';
    },
    isItemSelected(item) {
      return this.model.some(itm => itm[this.valueKey] === item[this.valueKey]);
    },
    removeSelection(item) {
      if (this.disabled || item.disabled) {
        return;
      }
      const indexToRemove = this.model.map(itm => itm[this.valueKey]).indexOf(item[this.valueKey]);
      this.$emit('remove', item);
      if (this.multiple) {
        const newValue = this.model.slice(0, indexToRemove).concat(this.model.slice(indexToRemove + 1));
        this.$emit('input', newValue);
      } else {
        this.$emit('input', null);
      }
    },
    select(item) {
      if (item.disabled) {
        return;
      }
      if (this.isItemSelected(item)) {
        if (this.multiple) {
          this.removeSelection(item);
        }
        return;
      }
      if (this.model.length && !this.multiple) {
        return;
      }
      this.$emit('select', item);
      if (this.multiple) {
        this.$emit('input', this.model.concat([item]));
      } else {
        this.$emit('input', item);
      }
    },
    getFilterHandler(prop) {
      let key;
      if (Array.isArray(prop)) {
        key = prop.join('');
      } else if (typeof prop === 'string' || prop instanceof String) {
        key = prop;
      } else {
        return () => false;
      }
      if (this.filterCache[key]) {
        return this.filterCache[key];
      }
      this.filterCache[key] = (item, filter) => Array.isArray(prop) ? prop.some(prp => filterItems(prp, item, filter)) : filterItems(prop, item, filter);
      return this.filterCache[key];
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-chooser-grid.vue2.js.map
